import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { LoaderIcon } from "react-hot-toast";
import { IEmbed } from "../../embedsV2/interface";
import { Button } from "../../../../../components/Button/Button";
import { MenuDrawer } from "../../../../../components/MenuOptions";
import { IconPlus } from "../../../../../utils/icons";
import VideoListingPopup from "./VideoListingPopup";

interface Props {
  embed?: IEmbed;
  onClose?: () => void;
  setShowSettingsModal?: (e: boolean) => void;
  onDelete?: () => void;
  refetch?: () => void;
}

export function Header({
  embed,
  onClose,
  setShowSettingsModal,
  refetch,
  ...rest
}: Props) {
  const [showVideosPopup, setVideosPopupView] = useState(false);

  if (!embed?.id) return <LoaderIcon />;

  return (
    <Box>
      <Box className="w-full flex justify-between items-start" marginTop={2}>
        <Typography variant="h4">
          {embed.name}
        </Typography>
        <Box className="flex gap-4 min-w-[255px]">
          <Button
            className="!flex gap-2 !px-4"
            onClick={() => setVideosPopupView(true)}
          >
            <IconPlus />
            <Typography>Add Video to Story</Typography>
          </Button>
          <MenuDrawer
            {...rest}
            title="story"
            isDetailedPage
            onEdit={() => setShowSettingsModal?.(true)}
          />
          {showVideosPopup && (
            <VideoListingPopup
              embedId={embed.id}
              prevSelectedVideos={embed.files.map(
                (e: any) => e?.review?.s3_file_id || e?.id
              )}
              onCompletion={() => {
                setVideosPopupView(false);
                refetch?.();
              }}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
}
